import styles from '../ExpressModeModal.module.css';

interface StepIndicatorProps {
  currentStep: number;
  totalSteps: number;
  labels: string[];
  maxStepReached?: number;
  onStepClick?: (step: number) => void;
  /** ナビゲーション対象から外すステップ (中間ローディング等)。クリック不可になる。 */
  nonNavigableSteps?: number[];
}

export function StepIndicator({ currentStep, totalSteps, labels, maxStepReached, onStepClick, nonNavigableSteps }: StepIndicatorProps) {
  const maxReached = maxStepReached ?? currentStep;

  return (
    <div className={styles.stepIndicator}>
      {Array.from({ length: totalSteps }, (_, i) => {
        const step = i + 1;
        const isActive = step === currentStep;
        const isCompleted = step < currentStep;
        const isReachable = step <= maxReached && step !== currentStep;
        const isClickable = isReachable && !!onStepClick && !nonNavigableSteps?.includes(step);
        return (
          <div
            key={step}
            className={`${styles.stepDot} ${isActive ? styles.stepActive : ''} ${isCompleted ? styles.stepCompleted : ''} ${isClickable ? styles.stepClickable : ''}`}
            onClick={isClickable ? () => onStepClick(step) : undefined}
            role={isClickable ? 'button' : undefined}
            tabIndex={isClickable ? 0 : undefined}
            onKeyDown={isClickable ? (e) => { if (e.key === 'Enter' || e.key === ' ') onStepClick(step); } : undefined}
          >
            <div className={styles.stepCircle}>
              {isCompleted ? (
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                  <polyline points="20 6 9 17 4 12" />
                </svg>
              ) : (
                <span>{step}</span>
              )}
            </div>
            <span className={styles.stepLabel}>{labels[i]}</span>
          </div>
        );
      })}
    </div>
  );
}
